<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Articles
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des articles</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Tabs -->
    <ul class="afri-tabs nav" style="padding: 0 1.5rem;">
      <li class="nav-item">
        <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" href="#tab-animated1-0" aria-selected="true">
          <span class="nav-text">Boutique</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" href="#tab-animated1-1" aria-selected="false">
          <span class="nav-text">Restaurant</span>
        </a>
      </li>
    </ul>

    <div class="tab-content">

      <!-- Tab 1: Boutique -->
      <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
            <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="selected_data" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
              </svg>
              Lire les commentaires <app-loading [isVisible]="loading"></app-loading>
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit2(editContent2)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
              Signaler un article
            </button>
            <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Image</th>
                <th>Nom</th>
                <th>Type</th>
                <th>Prix</th>
                <th>Promo</th>
                <th>Quantité</th>
                <th>Catégorie</th>
                <th>Pays</th>
                <th>Vendeur</th>
                <th>Boutique</th>
                <th>Contact</th>
                <th>Statut</th>
                <th>Likes</th>
                <th>Description</th>
                <th>Admin</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data | paginate: {
                    id: 'ngxP1',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>
                  <a *ngFor="let m of d.external_urls" [href]="m" target="_blank" class="pointer">
                    <img [src]="m" height="10px" alt="">
                  </a>
                </td>
                <td>{{d.name}}</td>
                <td>{{d.shelf?.name}}</td>
                <td>{{d.price}}</td>
                <td>{{d.promotional_price}}</td>
                <td>{{d.quantity}}</td>
                <td>{{d.category?.name}}</td>
                <td>{{d.country?.name}}</td>
                <td>{{d.user?.lastname}} {{d.user?.firstname}}</td>
                <td>{{d.store?.name}}</td>
                <td>{{d.user?.phone}}</td>
                <td>
                  <app-status [value]="d.status"></app-status>
                  <p *ngIf="d.status =='hidden'">{{d.motif}}</p>
                </td>
                <td>{{d.likes}}</td>
                <td>{{d.description}}</td>
                <td>-</td>
                <td>{{d.created_at | date:"dd-MMMM-yyyy"}}</td>
                <td>{{d.updated_at | date:"dd-MMMM-yyyy"}}</td>
              </tr>

              <tr *ngIf="data.length === 0 && !loading2">
                <td colspan="18" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP1"
            (pageChange)="getPage($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 1 -->

      <!-- Tab 2: Restaurant -->
      <div class="tab-pane" id="tab-animated1-1" role="tabpanel">

        <!-- Card header: actions + count -->
        <div class="afri-card-header">
          <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
            <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Ajouter
            </button>
            <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
              </svg>
              Consulter
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
              </svg>
              Lire les commentaires
            </button>
            <button *ngIf="buttonsPermission.edit" (click)="edit2(editContent2)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
              Signaler un article
            </button>
            <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
              Supprimer
            </button>
          </div>
          <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
            <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
            élément(s)
            <app-loading [isVisible]="loading2"></app-loading>
          </div>
        </div>

        <!-- Table -->
        <div style="overflow-x: auto;">
          <table class="afri-table">
            <thead>
              <tr>
                <th style="width: 52px; padding-left: 1.5rem;">#</th>
                <th>Image</th>
                <th>Nom</th>
                <th>Type</th>
                <th>Prix</th>
                <th>Promo</th>
                <th>Quantité</th>
                <th>Catégorie</th>
                <th>Pays</th>
                <th>Vendeur</th>
                <th>Boutique</th>
                <th>Contact</th>
                <th>Statut</th>
                <th>Likes</th>
                <th>Description</th>
                <th>Admin</th>
                <th>Ajouté le</th>
                <th>Modifié le</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of data2 | paginate: {
                    id: 'ngxP2',
                    itemsPerPage: pg2.pageSize,
                    currentPage: pg2.p,
                    totalItems: pg2.total
                  } | sampleSearch:search_text"
                  [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
                <td style="padding-left: 1.5rem;">
                  <input (click)="checked(d)" type="radio" name="selectRow"
                         style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
                </td>
                <td>
                  <a *ngFor="let m of d.external_urls" [href]="m" target="_blank" class="pointer">
                    <img [src]="m" height="10px" alt="">
                  </a>
                </td>
                <td>{{d.name}}</td>
                <td>{{d.shelf?.name}}</td>
                <td>{{d.price}}</td>
                <td>{{d.promotional_price}}</td>
                <td>{{d.quantity}}</td>
                <td>{{d.category?.name}}</td>
                <td>{{d.country?.name}}</td>
                <td>{{d.user?.lastname}} {{d.user?.firstname}}</td>
                <td>{{d.store?.name}}</td>
                <td>{{d.name}}</td>
                <td>
                  <app-status [value]="d.status"></app-status>
                  <p *ngIf="d.status =='hidden'">{{d.motif}}</p>
                </td>
                <td>{{d.likes}}</td>
                <td>{{d.name}}</td>
                <td>-</td>
                <td>{{d.created_at | date:"dd-MMMM-yyyy"}}</td>
                <td>{{d.updated_at | date:"dd-MMMM-yyyy"}}</td>
              </tr>

              <tr *ngIf="data2.length === 0 && !loading2">
                <td colspan="18" style="padding: 4rem 1.25rem; text-align: center;">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                    <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div style="padding: 0.5rem 1.5rem 1.25rem;">
          <pagination-controls
            id="ngxP2"
            (pageChange)="getPage2($event)"
            [maxSize]="9"
            [directionLinks]="true"
            [autoHide]="true"
            [responsive]="true"
            [previousLabel]="'Précédent'"
            [nextLabel]="'Suivant'">
          </pagination-controls>
        </div>

      </div><!-- end tab 2 -->

    </div><!-- end tab-content -->

  </div><!-- end card -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Enregistrer un rôle</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Libellé du rôle <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" ngModel>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Gestion des commentaires</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <table class="table table-sm">
      <thead>
        <th>#</th>
        <th>Commentaire</th>
        <th>Auteur</th>
        <th>Date Commentaire</th>
        <th>Action</th>
      </thead>
      <tbody>
        <tr *ngFor="let m of comments; let i=index">
          <td>{{i+1}}</td>
          <td>{{m.content}}</td>
          <td>{{m.user?.lastname}} {{m.user?.firstname}}</td>
          <td>{{m.created_at | date:"dd-MMMM-yyyy HH:mm:ss"}}</td>
          <td>
            <i class="fa fa-trash text-center pointer" (click)="delete2(m.id,i)" aria-hidden="true"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent2 let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Signaler un article</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Motif <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="motif" class="afri-input" ngModel>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <dl class="dl col-12 col-md-4">
        <dt>Libellé</dt>
        <dd>{{selected_data?.name}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Description</dt>
        <dd>{{selected_data?.description}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Prix</dt>
        <dd>{{selected_data?.price}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Prix promotionnel</dt>
        <dd>{{selected_data?.promotional_price}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Quantité</dt>
        <dd>{{selected_data?.quantity}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Article d'occas.</dt>
        <dd>{{selected_data?.is_new ? 'Oui':'Non'}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Fichiers</dt>
        <dd>
          <img *ngFor="let eu of selected_data?.external_urls" height="10px" [src]="eu" alt="" srcset="">
        </dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Likes</dt>
        <dd>{{selected_data?.likes}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Couleur</dt>
        <dd>
          <ul>
            <li *ngFor="let c of selected_data?.colors">{{c.name}}</li>
          </ul>
        </dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Dimensions</dt>
        <dd>
          @for (entry of getEntries(selected_data.dimensions); track entry.key) {
            <ul>
              <li>{{ entry.key }}: {{ entry.value.unit }} {{ entry.value.value }}</li>
            </ul>
          }
        </dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Rating</dt>
        <dd>{{selected_data?.rating?.value}} /{{selected_data?.rating?.count}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Adresse</dt>
        <dd>{{selected_data?.address}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Localisation</dt>
        <dd>{{selected_data?.location.lat}},{{selected_data?.location.lng}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Statut</dt>
        <dd><app-status [value]="selected_data?.status"></app-status></dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Favorisé</dt>
        <dd>{{selected_data?.isFavourite ? "Oui": "Non"}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Commentaire</dt>
        <dd>
          <ul>
            <li>{{selected_data?.content}}, {{selected_data?.created_at | date:"dd/MM/yyyy"}}</li>
          </ul>
        </dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Auteur</dt>
        <dd>{{selected_data?.user?.lastname}} {{selected_data?.user?.firstname}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Boutique</dt>
        <dd>{{selected_data?.store?.name}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Rayon</dt>
        <dd>{{selected_data?.shelf?.name}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Catégorie</dt>
        <dd>{{selected_data?.category?.name}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Sous catégorie</dt>
        <dd>{{selected_data?.subcategory?.name}}</dd>
      </dl>
      <dl class="dl col-12 col-md-4">
        <dt>Pays</dt>
        <dd>{{selected_data?.country?.name}}</dd>
      </dl>
    </div>
  </div>
</ng-template>
